export const generateWhatsAppLink = (phoneNumber, message) => {
  // This removes any spaces or dashes from the phone number
  const cleanNumber = phoneNumber.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
};
